import * as React from 'react';
import './TrialPersonnelEditPage.scss';
import { match } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import Alert from 'react-s-alert';
import { IPersonnelRoleReduxFormState, initialPersonnelRoleState } from "../../../reducers/reactReduxForms/personnelRole";
import { IRegistrationElement, RegistrationFormComponent, IRegistrationGrid } from "../../../interfaces/forms/IRegistrationComponent";
import { renderFormControls, RegistrationComponent, getFormProperty, getFormPropertyLabel } from "../../../helpers/formHelper";
import { renderRegistrationFormSaveSuccess, renderRegistrationFormSaveWarning, renderRegistrationFormSaveError, renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import { TextFormInput, DatePickerFormInputFabric, GenericFormGroup, RadioButtonSetFormInput, SelectFormInput, DatePickerFormInput, DatePickerPartialFormInput, MaskedFormInput, NumberFormInput, CheckboxFormInput, StaticFormInput, GenericMultiFormGroup, ValidationMessage } from "../../../components/form/index";
import * as PersonnelRoleActions from '../../../actions/personnelRole';
import * as TrialActions from '../../../actions/trial';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState, IRequestState } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { Link } from "../../../components/routing/index";
import { findLookup, generateOptionsFromLookup, generateSuggestionsFromLookup } from "../../../helpers/lookupHelper";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { Modal, NotificationAlert } from "../../../components/common/index";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { Form, actions, Control } from 'react-redux-form';
import * as FormHelper from '../../../helpers/formHelper';
import { TrialLayout } from '../../index';
import { inputProperties } from 'office-ui-fabric-react';
import SuggestionFormInput from 'src/components/form/inputs/SuggestionFormInput/SuggestionFormInput';
interface ITrialPersonnelEditPageParams {
  trialId: number;
  personnelRoleId: number;
}
interface ITrialPersonnelEditPageProps {
  form: Dtos.PersonnelRole & IRegistrationFormState;
  formState: Dtos.FormState;
  formProperties: Dtos.FormProperty[];
  reduxFormState: IPersonnelRoleReduxFormState;
  location: Location;
  trialId: number;
  personnelRoleId: number;
  match: match<ITrialPersonnelEditPageParams>;
  history: History;

  // From state
  personnelRole: Dtos.PersonnelRole;
  trial: Dtos.Trial;
  trialRoles: Dtos.RoleType[];
  lookups: Dtos.Lookup[];
  loadingTrial: boolean;
  loadingPersonnelRole: boolean;
  loadPersonnelRoleSuccess: boolean;
  loadPersonnelRoleFailure: boolean;
  savingPersonnelRole: boolean;
  savePersonnelRoleSuccess: boolean;
  savePersonnelRoleFailure: boolean;
  creatingPersonnelRole: boolean;
  createPersonnelRoleSuccess: boolean;
  createPersonnelRoleFailure: boolean;
  resendingState: IRequestState;
  resending: boolean;
  resendSuccess: boolean;
  resendFailure: boolean;
  validationFailures: Dtos.ResponseError[];
  permissions?: Dtos.PersonnelTmdPermissions[];
  user: Dtos.User;
}
interface ITrialPersonnelEditPageActions {
  clearPersonnelRole: PersonnelRoleActions.IPersonnelRoleClearActionCreator;
  loadPersonnelRole: PersonnelRoleActions.IPersonnelRoleLoadByIdActionCreator;
  savePersonnelRole: PersonnelRoleActions.IPersonnelRoleSaveActionCreator;
  createPersonnelRole: PersonnelRoleActions.IPersonnelRoleCreateActionCreator;
  clearTrial: TrialActions.ITrialClearActionCreator;
  loadTrial: TrialActions.ITrialLoadByIdActionCreator;
  resend: PersonnelRoleActions.IPersonnelRoleResendEmailActionCreator;
  loadForm: typeof actions.load;
  changeForm: typeof actions.change;
  resetForm: typeof actions.reset;
  navigate: typeof routerActions.push;
  navigateReplace: typeof routerActions.replace;
}
type TrialPersonnelEditPageProps = ITrialPersonnelEditPageProps & ITrialPersonnelEditPageActions;
const formName: string = "personnelRole";
const reduxFormName: string = "reduxForms.personnelRole";
const tableHeaderClass = "btn btn-primary btn-block rounded-0 p-3 d-flex";
const tableStyleClass: React.CSSProperties = {
  textAlign: "left",
  fontWeight: "bold",
  color: "white",
  cursor: "pointer"
};
class TrialPersonnelEditPage extends React.PureComponent<TrialPersonnelEditPageProps, any> {
  constructor(props: TrialPersonnelEditPageProps) {
    super(props);
    this.state = {
      showUsernameWarning: false
    };
    this.clearPersonnelRole = this.clearPersonnelRole.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.loadForm = this.loadForm.bind(this);
    this.changeShowUsernameWarning = this.changeShowUsernameWarning.bind(this);
  }
  componentDidMount() {
    const {
      loadPersonnelRole,
      createPersonnelRole,
      navigate,
      navigateReplace,
      personnelRoleId,
      trialId,
      loadTrial
    } = this.props;
    if (personnelRoleId) {
      loadPersonnelRole(personnelRoleId);
    } else if (!personnelRoleId) {
      createPersonnelRole(null, trialId, null, null, null);
    }
    loadTrial(trialId, true, false, true, false, false);
  }
  componentWillReceiveProps(nextProps: TrialPersonnelEditPageProps) {}
  componentDidUpdate(prevProps: TrialPersonnelEditPageProps, prevState) {
    const {
      form,
      trialId,
      personnelRoleId,
      personnelRole,
      navigateReplace,
      loadPersonnelRole,
      loadTrial,
      loadingPersonnelRole,
      loadPersonnelRoleSuccess,
      savingPersonnelRole,
      savePersonnelRoleSuccess,
      savePersonnelRoleFailure,
      createPersonnelRole,
      validationFailures,
      creatingPersonnelRole,
      createPersonnelRoleSuccess,
      navigate,
      resending,
      resendFailure,
      resendSuccess
    } = this.props;
    if (trialId && prevProps.trialId != trialId) {
      loadTrial(trialId, true, false, true, false, false);
      if (this.state.showUsernameWarning) {
        this.setState({
          showUsernameWarning: false
        });
      }
    }
    if (personnelRoleId && prevProps.personnelRoleId != personnelRoleId) {
      loadPersonnelRole(personnelRoleId);
      if (this.state.showUsernameWarning) {
        this.setState({
          showUsernameWarning: false
        });
      }
    } else if (!personnelRoleId && prevProps.personnelRoleId) {
      createPersonnelRole(null, trialId, null, null, null);
      if (this.state.showUsernameWarning) {
        this.setState({
          showUsernameWarning: false
        });
      }
    }
    if (!loadingPersonnelRole && prevProps.loadingPersonnelRole) {
      if (loadPersonnelRoleSuccess) {
        this.loadForm();
      } else {}
    }
    if (!savingPersonnelRole && prevProps.savingPersonnelRole) {
      if (savePersonnelRoleSuccess) {
        if (validationFailures && validationFailures.length > 0) {
          Alert.warning(<NotificationAlert alertContent={renderRegistrationFormSaveWarning(validationFailures)} icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE} />);

          // toggleMessageModal();
        } else {
          Alert.success(<NotificationAlert alertContent={renderRegistrationFormSaveSuccess()} icon={FontAwesomeIcons.Solid.CHECK} />);
        }
        if (form.saveAndReturn) {
          navigate("/trials/" + trialId + "/personnel");
        } else if (!form.saveAndReturn && personnelRoleId && personnelRole && personnelRole.id != personnelRoleId) {
          navigate("/trials/" + trialId + "/personnel/" + personnelRole.id);
        } else if (!form.saveAndReturn && personnelRoleId && personnelRoleId > 0) {
          this.loadForm();
        } else if (!form.saveAndReturn && !personnelRoleId && personnelRole && personnelRole.id > 0) {
          navigate("/trials/" + trialId + "/personnel/" + personnelRole.id);
          this.loadForm();
        }
      } else {
        Alert.error(<NotificationAlert alertContent={this.renderErrorAlert()} icon={FontAwesomeIcons.Solid.TIMES_OCTAGON} />);
      }
    }
    if (!creatingPersonnelRole && prevProps.creatingPersonnelRole) {
      if (createPersonnelRoleSuccess) {
        this.loadForm();
      } else {}
    }
    if (!resending && prevProps.resending) {
      if (resendSuccess) {
        Alert.success(<NotificationAlert alertContent={<div>Personnel trial role assigned email sent</div>} icon={FontAwesomeIcons.Solid.CHECK} />);
      }
      if (resendFailure) {
        if (this.props.resendingState.errorMessage) {
          Alert.error(<NotificationAlert alertContent={<div>{this.props.resendingState.errorMessage}</div>} icon={FontAwesomeIcons.Solid.TIMES_OCTAGON} />);
        } else {
          Alert.error(<NotificationAlert alertContent={<div>The personnel trial role assigned was <strong> not </strong> sent</div>} icon={FontAwesomeIcons.Solid.TIMES_OCTAGON} />);
        }
      }
    }
  }
  componentWillUpdate(nextProps: TrialPersonnelEditPageProps) {}
  componentWillUnmount() {
    const {
      resetForm,
      loadForm
    } = this.props;
    this.clearPersonnelRole();
    loadForm(reduxFormName, initialPersonnelRoleState);
    resetForm(reduxFormName);
  }
  changeShowUsernameWarning(value: boolean) {
    this.setState({
      showUsernameWarning: value
    });
  }
  clearPersonnelRole() {
    this.props.clearPersonnelRole();
    this.props.clearTrial();
  }
  showPersonnelRole(): boolean {
    const {
      loadingTrial,
      loadingPersonnelRole,
      loadPersonnelRoleSuccess,
      creatingPersonnelRole
    } = this.props;
    if (!loadingTrial && !loadingPersonnelRole && loadPersonnelRoleSuccess && !creatingPersonnelRole) {
      return true;
    }
    return false;
  }
  render() {
    const {
      loadingPersonnelRole,
      creatingPersonnelRole
    } = this.props;
    return <TrialLayout loading={loadingPersonnelRole || creatingPersonnelRole} permission={Dtos.Permission.TrialPersonnelRoleView} data-sentry-element="TrialLayout" data-sentry-component="TrialPersonnelEditPage" data-sentry-source-file="TrialPersonnelEditPage.tsx">{this.renderContent()}</TrialLayout>;
  }
  renderContent() {
    const {
      form,
      lookups,
      validationFailures,
      formProperties,
      formState,
      changeForm,
      trialRoles,
      resending,
      resend,
      savingPersonnelRole,
      permissions
    } = this.props;
    let self = this;
    let noPermissionToEditMessage = false;
    if (form.id && form.id > 0 && validationFailures && validationFailures.filter(f => f.errorCode == "PR-005").length > 0) {
      noPermissionToEditMessage = true;
    }
    const hasPermission: boolean = AuthenticationHelper.hasCreateEditPermission(form, permissions, Dtos.Permission.TrialPersonnelRoleUpdate, Dtos.Permission.TrialPersonnelRoleCreate);
    const formDisabledOnEdit: boolean = !hasPermission || FormHelper.isEdit(formState, form);
    const formNew: boolean = FormHelper.isNew(formState, form);
    const formDisabled: boolean = !hasPermission || savingPersonnelRole || formState && formState.formStatus == Dtos.FormStatus.Disabled || noPermissionToEditMessage;
    const departmentLookup: string = form.institutionId && form.institutionId > 0 ? form.institutionId.toString() + "DepartmentId" : "DepartmentId";
    const formCreatePersonnel: boolean = formNew && form.createNewPersonnel;
    let activeDirectoryError: string = "";
    if (validationFailures) {
      validationFailures.forEach(validationFailure => {
        if (validationFailure.errorCode === "AD-099") {
          activeDirectoryError = validationFailure.message;
        }
      });
    }
    let formComponents: {
      [index: string]: RegistrationFormComponent;
    } = {
      parent: {
        type: RegistrationComponent.RegistrationElement,
        component: <div>
                    {renderFormControls(form, "PersonnelRole", {
            trialDisplay: {
              type: RegistrationComponent.RegistrationControl,
              inputType: TextFormInput,
              inputDisabled: true,
              groupClassName: form.trialDisplay == '' ? "form-group-hide" : "form-group row border border-bottom-1 border-top-0 pb-4 pt-4"
            },
            institutionDisplay: {
              type: RegistrationComponent.RegistrationControl,
              inputType: TextFormInput,
              inputDisabled: true,
              groupClassName: form.institutionDisplay == '' ? "form-group-hide" : "form-group row border border-bottom-1 border-top-0 pb-4 pt-4"
            },
            groupDisplay: {
              type: RegistrationComponent.RegistrationControl,
              inputType: TextFormInput,
              inputDisabled: true,
              groupClassName: form.groupDisplay == '' ? "form-group-hide" : "form-group row border border-bottom-1 border-top-0 pb-4 pt-4"
            }
          }, lookups, validationFailures, formProperties, changeForm)}
                </div>
      },
      institutionId: {
        type: RegistrationComponent.RegistrationControl,
        inputType: SelectFormInput,
        inputDisabled: formDisabledOnEdit,
        inputProps: {
          options: generateOptionsFromLookup(findLookup("PersonnelRole", "InstitutionId", lookups), form.institutionId),
          placeholder: form.createNewInstitution ? "New Institution" : "All institutions"
        },
        changeAction: (model, value, form, parentModel) => {
          changeForm(model, value);
          changeForm(reduxFormName + parentModel + '.departmentId', null);
        },
        hide: !formNew
      },
      personnelId: {
        type: RegistrationComponent.RegistrationControl,
        inputType: SelectFormInput,
        inputDisabled: formDisabledOnEdit || formCreatePersonnel,
        inputProps: {
          options: generateOptionsFromLookup(findLookup("PersonnelRole", "PersonnelId", lookups), form.personnelId)
        }
      },
      createNewPersonnel: {
        type: RegistrationComponent.RegistrationControl,
        inputType: CheckboxFormInput,
        inputDisabled: formDisabled,
        inputProps: {
          label: "Create a new personnel"
        },
        inputLabel: " ",
        changeAction: (model, value, form, parentModel) => {
          changeForm(model, value);
          if (value) {
            changeForm(reduxFormName + parentModel + '.personnelId', null);
          } else {
            changeForm(reduxFormName + parentModel + '.salutationId', null);
            changeForm(reduxFormName + parentModel + '.firstName', null);
            changeForm(reduxFormName + parentModel + '.lastName', null);
            changeForm(reduxFormName + parentModel + '.email', null);
            changeForm(reduxFormName + parentModel + '.userName', null);
            self.changeShowUsernameWarning(false);
          }
        },
        groupClassName: !formNew ? "form-group-hide" : "form-group row border border-bottom-1 border-top-0 pb-4 pt-4"
      },
      salutationId: {
        type: RegistrationComponent.RegistrationControl,
        inputType: SelectFormInput,
        inputDisabled: formDisabled || !formCreatePersonnel,
        inputProps: {
          options: generateOptionsFromLookup(findLookup("PersonnelRole", "SalutationId", lookups), form.salutationId)
        },
        groupClassName: !formCreatePersonnel ? "form-group-hide" : "form-group row border border-bottom-1 border-top-0 pb-4 pt-4"
      },
      firstName: {
        type: RegistrationComponent.RegistrationControl,
        inputType: TextFormInput,
        inputDisabled: formDisabled || !formCreatePersonnel,
        blurAction: (form, parentModel) => {
          if (form.firstName && form.firstName != '' && form.lastName && form.lastName != '' && (!form.userName || form.userName == '')) {
            changeForm("reduxForms.personnelRole.userName", (form.firstName[0] + "." + form.lastName).toLowerCase().trim());
            self.changeShowUsernameWarning(true);
          }
        },
        groupClassName: !formCreatePersonnel ? "form-group-hide" : "form-group row border border-bottom-1 border-top-0 pb-4 pt-4"
      },
      lastName: {
        type: RegistrationComponent.RegistrationControl,
        inputType: TextFormInput,
        inputDisabled: formDisabled || !formCreatePersonnel,
        blurAction: (form, parentModel) => {
          if (form.firstName && form.firstName != '' && form.lastName && form.lastName != '' && (!form.userName || form.userName == '')) {
            changeForm("reduxForms.personnelRole.userName", (form.firstName[0] + "." + form.lastName).toLowerCase().trim());
            self.changeShowUsernameWarning(true);
          }
        },
        groupClassName: !formCreatePersonnel ? "form-group-hide" : "form-group row border border-bottom-1 border-top-0 pb-4 pt-4"
      },
      email: {
        type: RegistrationComponent.RegistrationControl,
        inputType: TextFormInput,
        inputDisabled: formDisabled || !formCreatePersonnel,
        groupClassName: !formCreatePersonnel ? "form-group-hide" : "form-group row border border-bottom-1 border-top-0 pb-4 pt-4"
      },
      personnelInstitutionId: {
        type: RegistrationComponent.RegistrationControl,
        inputType: SelectFormInput,
        inputDisabled: formDisabled,
        size: 2,
        inputProps: {
          options: generateOptionsFromLookup(findLookup("PersonnelProfessionalDetails", "InstitutionId", lookups), form.personnelInstitutionId)
        },
        groupClassName: !formCreatePersonnel ? "form-group-hide" : "form-group row border border-bottom-1 border-top-0 pb-4 pt-4",
        hide: !formNew
      },
      personnelInstitutionOther: {
        type: RegistrationComponent.RegistrationControl,
        inputType: TextFormInput,
        inputDisabled: formDisabledOnEdit,
        size: 2,
        groupClassName: !formCreatePersonnel ? "form-group-hide" : "form-group row border border-bottom-1 border-top-0 pb-4 pt-4",
        hide: !formNew
      },
      jobTitle: {
        type: RegistrationComponent.RegistrationControl,
        inputType: TextFormInput,
        inputDisabled: formDisabled,
        size: 1,
        groupClassName: !formCreatePersonnel ? "form-group-hide" : "form-group row border border-bottom-1 border-top-0 pb-4 pt-4"
      },
      professionalDisciplineId: {
        type: RegistrationComponent.RegistrationControl,
        inputType: SelectFormInput,
        inputDisabled: formDisabled,
        inputProps: {
          options: generateOptionsFromLookup(findLookup("PersonnelRole", "ProfessionalDisciplineId", lookups), form.professionalDisciplineId)
        },
        size: 1,
        groupClassName: !formCreatePersonnel ? "form-group-hide" : "form-group row border border-bottom-1 border-top-0 pb-4 pt-4"
      },
      otherDisciplines: {
        type: RegistrationComponent.RegistrationControl,
        inputType: TextFormInput,
        inputDisabled: formDisabled || form && form.professionalDisciplineId == null || form && form.professionalDisciplineId != 15,
        size: 1,
        groupClassName: !formCreatePersonnel ? "form-group-hide" : "form-group row border border-bottom-1 border-top-0 pb-4 pt-4"
      },
      workStateId: {
        type: RegistrationComponent.RegistrationControl,
        inputType: SelectFormInput,
        size: 1,
        inputDisabled: formDisabled,
        inputProps: {
          options: generateOptionsFromLookup(findLookup("PersonnelRole", "WorkStateId", lookups), form.workStateId)
        },
        changeAction: (model, value, form, parentModel) => {
          changeForm(model, value);
          changeForm(reduxFormName + parentModel + '.workState', null);
          if (value == null || value != 10) {
            changeForm(reduxFormName + parentModel + '.workStateOther', null);
          }
        },
        groupClassName: !formCreatePersonnel ? "form-group-hide" : "form-group row border border-bottom-1 border-top-0 pb-4 pt-4"
      },
      workStateOther: {
        type: RegistrationComponent.RegistrationControl,
        inputType: TextFormInput,
        inputDisabled: formDisabled || form && form.workStateId == null || form && form.workStateId != 10,
        size: 1,
        groupClassName: !formCreatePersonnel ? "form-group-hide" : "form-group row border border-bottom-1 border-top-0 pb-4 pt-4"
      },
      workCountryId: {
        type: RegistrationComponent.RegistrationControl,
        inputType: SelectFormInput,
        inputDisabled: formDisabled,
        inputProps: {
          options: generateOptionsFromLookup(findLookup("PersonnelRole", "WorkCountryId", lookups), form.workCountryId)
        },
        size: 1,
        groupClassName: !formCreatePersonnel ? "form-group-hide" : "form-group row border border-bottom-1 border-top-0 pb-4 pt-4"
      },
      userName: {
        type: RegistrationComponent.RegistrationControl,
        inputType: TextFormInput,
        inputDisabled: formDisabled || !formCreatePersonnel,
        groupClassName: !formCreatePersonnel ? "form-group-hide" : "form-group row border border-bottom-1 border-top-0 pb-4 pt-4",
        changeAction: (model, value, form, parentModel) => {
          changeForm(model, value);
          self.changeShowUsernameWarning(false);
        }
      },
      activeDirectoryError: {
        type: RegistrationComponent.RegistrationElement,
        size: 1,
        hide: !activeDirectoryError,
        component: <div className="col-md-12 mt-2">
                    <div className="alert alert-danger d-flex">
                        <div className="mr-2">
                            <FontAwesomeIcon icon={FontAwesomeIcons.Solid.EXCLAMATION_TRIANGLE} fixedWidth />
                        </div>
                        <span>{activeDirectoryError}</span>
                    </div>
                </div>
      },
      usernameWarning: {
        type: RegistrationComponent.RegistrationElement,
        component: <>
                    {this.state.showUsernameWarning && <div className="col-md-12 mt-2">
                            <div className="alert alert-info d-flex">
                                <div className="mr-2">
                                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                                </div>
                                <span>Username was auto-generated based on the first and last name, if the username generated is attached to another personnel, please amend until a unique username is achieved.</span>
                            </div>
                        </div>}
                </>
      },
      roleId: {
        type: RegistrationComponent.RegistrationControl,
        inputType: SelectFormInput,
        inputDisabled: formDisabled,
        inputProps: {
          options: generateOptionsFromLookup(findLookup("PersonnelRole", "RoleId", lookups), form.roleId)
        },
        changeAction: (model, value, form, parentModel) => {
          changeForm(model, value);
          if (value && form.originalRoleId != value && form.originalRoleId !== undefined) {
            changeForm(reduxFormName + parentModel + '.dateStarted', null);
          }
        }
      },
      departmentId: {
        type: RegistrationComponent.RegistrationControl,
        inputType: SelectFormInput,
        inputDisabled: formDisabled || form.createNewDepartment,
        inputProps: {
          options: generateOptionsFromLookup(findLookup("PersonnelRole", departmentLookup, lookups), form.departmentId),
          placeholder: "No Department"
        },
        hide: !form.institutionId || form.institutionId == 0
      },
      createNewDepartment: {
        type: RegistrationComponent.RegistrationControl,
        inputType: CheckboxFormInput,
        inputDisabled: formDisabled,
        inputProps: {
          label: "Create a new department"
        },
        inputLabel: " ",
        changeAction: (model, value, form, parentModel) => {
          changeForm(model, value);
          if (value) {
            changeForm(reduxFormName + parentModel + '.departmentId', null);
          } else {
            changeForm(reduxFormName + parentModel + '.newDepartment', null);
          }
        },
        hide: !form.institutionId || form.institutionId == 0
      },
      newDepartment: {
        type: RegistrationComponent.RegistrationControl,
        inputType: TextFormInput,
        inputDisabled: formDisabled,
        groupClassName: !form.createNewDepartment ? "form-group-hide" : "form-group row border border-bottom-1 border-top-0 pb-4 pt-4",
        changeAction: (model, value, form, parentModel) => {
          changeForm(model, value);
        },
        hide: !form.institutionId || form.institutionId == 0 || !form.createNewDepartment
      },
      dateStarted: {
        type: RegistrationComponent.RegistrationControl,
        inputType: DatePickerFormInputFabric,
        validationMessageAbove: true,
        inputDisabled: formDisabled
      },
      noEmailCommunication: {
        type: RegistrationComponent.RegistrationControl,
        inputType: CheckboxFormInput,
        inputDisabled: formDisabled,
        inputProps: {
          label: "No TROG systems access email communications"
        },
        inputLabel: " "
      },
      active: {
        type: RegistrationComponent.RegistrationControl,
        inputType: CheckboxFormInput,
        inputDisabled: formDisabled,
        inputProps: {
          label: "Active"
        },
        inputLabel: " ",
        changeAction: (model, value, form, parentModel) => {
          changeForm(model, value);
          if (value) {
            changeForm(reduxFormName + parentModel + '.dateCeased', null);
          }
        }
      },
      dateCeased: {
        type: RegistrationComponent.RegistrationControl,
        inputType: DatePickerFormInputFabric,
        validationMessageAbove: true,
        inputDisabled: formDisabled,
        disabledFn: (form: Dtos.PersonnelRole, arrayKey: string) => {
          if (form) {
            if (form.active) {
              return true;
            }
          }
          return false;
        }
      }
    };
    return <div>
            <h3>Personnel Role</h3>
            <Form model={reduxFormName} onSubmit={(val, event) => this.handleOnSubmit(val)} onSubmitFailed={val => this.handleOnSubmitFailed(val)}>
                {!formNew && !form.hasActiveDirectoryEntry && <div className="alert alert-info d-flex">
                        <div className="mr-2">
                            <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                        </div>
                        <span>This personnel does not have an Active Directory record that is required to access this site and registration websites. <Link url={"/personnel/" + form.personnelId + "/activedirectory"}>(edit login details)</Link></span>
                    </div>}
                {noPermissionToEditMessage && <div className="alert alert-warning d-flex mt-2 mb-2">
                        <div className="mr-2">
                            <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                        </div>
                        <span>You cannot edit a role that is higher than your own.</span>
                    </div>}
                {renderFormControls(form, "personnelRole", formComponents, lookups, validationFailures, formProperties, changeForm)}

                <div className="mt-4 mb-4 text-right">
                    {form.active && <button disabled={resending || formDisabled} onClick={() => {
            resend(form.id);
          }} type="button" className="btn btn-warning mr-2">
                            Re-send Email
                        </button>}
                    <button disabled={formDisabled} onClick={() => {
            this.props.changeForm(reduxFormName + ".saveAndReturn", false || form.createNewPersonnel);
          }} type="submit" className="btn btn-primary mr-2">
                        Submit
                    </button>

                    <button disabled={formDisabled} onClick={() => {
            this.props.changeForm(reduxFormName + ".saveAndReturn", true);
          }} type="submit" className="btn btn-primary mr-2">
                        Submit And Return
                    </button>
                    <button onClick={this.onCancel} className="btn btn-primary mr-2"> Cancel </button>
                </div>
            </Form>
        </div>;
  }
  renderErrorAlert(): any {
    const {
      validationFailures
    } = this.props;
    return <div>
            The form was <strong> not </strong> saved.
        </div>;
  }
  renderWarningAlert(): any {
    const {
      validationFailures
    } = this.props;
    return <div>
            The form was saved but was invalid with {validationFailures.length} errors.
        </div>;
  }
  renderSaveSuccessAlert(): any {
    return <div>The form has been saved successfully</div>;
  }
  handleOnSubmit(data: Dtos.PersonnelRole) {
    const {
      savePersonnelRole
    } = this.props;
    if (data) {
      let changes: Dtos.PersonnelRole = ({} as Dtos.PersonnelRole);
      savePersonnelRole(Object.assign({
        ...data
      }, changes));
    }
  }
  handleOnSubmitFailed(data: Dtos.TrialInstitution) {
    Alert.error(<NotificationAlert minWidth={500} alertContent={renderRegistrationFormSaveBlock()} icon={FontAwesomeIcons.Solid.BAN} />);
  }
  onCancel() {
    const {
      trialId,
      navigate
    } = this.props;
    navigate("/trials/" + trialId + "/personnel");
  }
  loadForm() {
    const {
      loadForm,
      personnelRole
    } = this.props;
    let extraData: Dtos.PersonnelRole = ({} as Dtos.PersonnelRole);
    loadForm(reduxFormName, Object.assign({
      ...personnelRole
    }, extraData));
  }
}
const mapStateToProps = (state: ITmdState, ownProps: TrialPersonnelEditPageProps): ITrialPersonnelEditPageProps => {
  let personnelRole: Dtos.PersonnelRole | undefined = !(state.personnelRole.formData instanceof Array) ? state.personnelRole.formData : undefined;
  let trial: Dtos.Trial | undefined = !(state.trials.formData instanceof Array) ? state.trials.formData : undefined;
  let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
  return {
    match: ownProps.match,
    trialId: ownProps.match ? ownProps.match.params.trialId : undefined!,
    personnelRoleId: ownProps.match && ownProps.match.params.personnelRoleId.toString() != "create" ? ownProps.match.params.personnelRoleId : undefined!,
    history: ownProps.history,
    location: state.routing.location,
    personnelRole: personnelRole!,
    trial: trial!,
    trialRoles: state.trials.formRoles,
    loadingPersonnelRole: state.personnelRole.loadState && state.personnelRole.loadState.status == RequestState.Pending,
    loadPersonnelRoleSuccess: state.personnelRole.loadState && state.personnelRole.loadState.status == RequestState.Success,
    loadPersonnelRoleFailure: state.personnelRole.loadState && state.personnelRole.loadState.status == RequestState.Failure,
    savingPersonnelRole: state.personnelRole.saveState && state.personnelRole.saveState.status == RequestState.Pending,
    savePersonnelRoleSuccess: state.personnelRole.saveState && state.personnelRole.saveState.status == RequestState.Success,
    savePersonnelRoleFailure: state.personnelRole.saveState && state.personnelRole.saveState.status == RequestState.Failure,
    creatingPersonnelRole: state.personnelRole.createState && state.personnelRole.createState.status == RequestState.Pending,
    createPersonnelRoleSuccess: state.personnelRole.createState && state.personnelRole.createState.status == RequestState.Success,
    createPersonnelRoleFailure: state.personnelRole.createState && state.personnelRole.createState.status == RequestState.Failure,
    loadingTrial: state.trials.loadState && state.trials.loadState.status == RequestState.Pending,
    resendingState: state.personnelRole.resendingState,
    resending: state.personnelRole.resendingState && state.personnelRole.resendingState.status == RequestState.Pending,
    resendSuccess: state.personnelRole.resendingState && state.personnelRole.resendingState.status == RequestState.Success,
    resendFailure: state.personnelRole.resendingState && state.personnelRole.resendingState.status == RequestState.Failure,
    user: state.user.data,
    permissions: permissions,
    lookups: state.personnelRole.lookups,
    form: state.reduxForms.personnelRole,
    formState: state.personnelRole.formState,
    formProperties: state.personnelRole.formProperties,
    reduxFormState: state.reduxForms.formState.personnelRole,
    validationFailures: personnelRole ? state.personnelRole.validationFailures : undefined
  };
};
const mapDispatchToProps = (dispatch): ITrialPersonnelEditPageActions => {
  return {
    navigate: bindActionCreators(routerActions.push, dispatch),
    navigateReplace: bindActionCreators(routerActions.replace, dispatch),
    loadForm: bindActionCreators(actions.load, dispatch),
    changeForm: bindActionCreators(actions.change, dispatch),
    resetForm: bindActionCreators(actions.reset, dispatch),
    loadPersonnelRole: bindActionCreators(PersonnelRoleActions.LoadPersonnelRoleById, dispatch),
    clearPersonnelRole: bindActionCreators(PersonnelRoleActions.Clear, dispatch),
    createPersonnelRole: bindActionCreators(PersonnelRoleActions.CreatePersonnelRole, dispatch),
    savePersonnelRole: bindActionCreators(PersonnelRoleActions.SavePersonnelRole, dispatch),
    resend: bindActionCreators(PersonnelRoleActions.ResendEmail, dispatch),
    loadTrial: bindActionCreators(TrialActions.LoadTrialById, dispatch),
    clearTrial: bindActionCreators(TrialActions.Clear, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(TrialPersonnelEditPage);